import { request } from './core'

export interface SignoffSummary {
  status: string // none | sent | delivered | completed | declined | voided | failed
  envelope_id: string | null
  signer_email: string | null
  sent_at: string | null
  completed_at: string | null
  error: string | null
  can_send?: boolean
  blocked_reason?: string
  revision?: number
}

export const signoffApi = {
  getSignoff: (slug: string) =>
    request<SignoffSummary>(`/api/assessments/${slug}/signoff`),

  /** Send the customer sign-off PDF for e-signature. `email`/`name` override the
   *  captured signatory — used to route a test envelope to your own inbox. */
  sendSignoff: (slug: string, opts: { email?: string; name?: string } = {}, revision?: number) =>
    request<SignoffSummary>(
      `/api/assessments/${slug}/signoff/send`,
      { method: 'POST', body: JSON.stringify(opts) },
      { ifMatch: revision },
    ),

  /** Manual fallback for a missed webhook: poll DocuSign + pull the signed PDF. */
  refreshSignoff: (slug: string, revision?: number) =>
    request<SignoffSummary>(
      `/api/assessments/${slug}/signoff/refresh`,
      { method: 'POST' },
      { ifMatch: revision },
    ),
}
